const utm = {
    init() {
        if (window.utmApi && window.utmSetterUrl) {
            fetch(window.utmApi)
                .then(response => response.json())
                .then(json => new URLSearchParams(json.data).toString())
                .then(params => fetch(`${window.utmSetterUrl}?${params}`));
        }
    },
};

export default utm;
